import React from 'react'
import { Checkbox, Input, Row, Col, message, Spin } from 'antd'
import { RcFile } from 'antd/es/upload'
import * as API from '../../../../api'

export interface AudioToTextProps {
	value?: string;
	onChange?: (val: string) => void;
	file?: RcFile;
	disabled?: boolean;
}

export interface AudioToTextState {
	text: string;
	checkVals: string[];
	loading: boolean;
}

class AudioToText extends React.Component<AudioToTextProps, AudioToTextState> {
	static defaultProps = {
		disabled: false,
	}

	state: AudioToTextState = {
		text: '',
		checkVals: [],
		loading: false,
	}

	componentDidMount() {
		this.initValue()
	}

	componentDidUpdate(prevProps) {
		const { file, value } = this.props
		if (JSON.stringify(prevProps.file) !== JSON.stringify(file)) {
			this.onCheckChange([])
			this.onTextChange('')
			this.setState({
				loading: false,
			})
		}
		if (prevProps.value !== value) {
			this.initValue()
		}
	}

	initValue = () => {
		const { value } = this.props
		if (!value) return
		if (this.props.disabled) {
			this.onTextChange('')
			this.setState({
				checkVals: [],
			})
		} else {
			this.onTextChange(value)
			this.setState({
				checkVals: ['toText'],
			})
		}
	}

	getTextFromAudioSrc = async () => {
		const { file } = this.props
		if (!file) {
			message.error('请选择音频文件')
			return
		}
		this.setState({ loading: true })
		try {
			const { code, data, msg } = await API.audioToText(file)
			this.setState({ loading: false })
			if (code === 0) {
				console.log('audio to text: ', data)
				this.onTextChange(data)
			} else {
				message.error(msg)
				this.onCheckChange([])
			}
		} catch (error) {
			console.log('音频转文字 error: ', error)
			message.error('音频转文字失败！')
			this.setState({ loading: false })
			this.onCheckChange([])
		}
	}

	onCheckChange = (val) => {
		this.setState({ checkVals: val })
		if (val.includes('toText')) {
			this.getTextFromAudioSrc()
		} else {
			// TODO
		}
	}

	onTextChange = (val) => {
		const { onChange } = this.props
		this.setState({ text: val })
		onChange && onChange(val)
	}

	render() {
		const { text, checkVals, loading } = this.state
		const { disabled } = this.props
		return (
			<Row gutter={10}>
				<Col span={5}>
					<Checkbox.Group disabled={disabled} value={checkVals} onChange={this.onCheckChange}>
						<Checkbox value="toText" disabled={loading}>转文字</Checkbox>
					</Checkbox.Group>
				</Col>
				<Col span={19}>
					<Spin tip="文本转换中..." spinning={loading} >
						<Input.TextArea rows={4} disabled={disabled} value={text} onChange={this.onTextChange}></Input.TextArea>
					</Spin>
				</Col>
			</Row>
		)
	}
}

export default AudioToText